import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from 'src/app/shared/shared.module';
import { TenantContinuousUpdateComponent } from './tenant-continuous-update.component';
import { TenantContinuousUpdateRoutingModule } from './tenant-continuous-update-routing.module';
import {MatIconModule} from '@angular/material/icon';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {PaginatorModule} from 'src/app/components/paginator/paginator.module';
import {TableModule} from 'src/app/table/table.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatCardModule} from '@angular/material/card';
import {PlayButtonModule} from 'src/app/components/play-button/play-button.module';
import {IconsModule} from 'src/app/icons/icons.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorModule} from 'src/app/components/error/error.module';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatSortModule} from '@angular/material/sort';
import { InstanceDetailsModule } from 'src/app/components/instance-details/instance-details.module';
import {SearchFilterModule} from '../../components/search-filter/search-filter.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { ViewInstanceComponent } from './view-instance/view-instance.component';
import { ViewInstanceDetailsComponent } from './view-instance-details/view-instance-details.component';
import { UpdateBuildComponent } from './update-build/update-build.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { MatSelectModule } from '@angular/material/select';
import { UpdateBuildPopupComponent } from './update-build-popup/update-build-popup.component';
import { PackageUpdatePopupComponent } from './package-update-popup/package-update-popup.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ExternalPackageDetailsComponent } from '../external-package/external-package-details/external-package-details.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { ComponentUpdateComponent } from './component-update/component-update.component';
import { ComponentDependencyComponent } from './component-dependency/component-dependency.component';
import { InfraUpgradeModule } from '../infra-upgrade/infra-upgrade.module';
import { EnvironmentSizingDocumentsModule } from '../environment-details/environment-sizing-documents/environment-sizing-documents.module';
@NgModule({
  declarations: [
    TenantContinuousUpdateComponent,
    ViewInstanceComponent,
    ViewInstanceDetailsComponent,
    UpdateBuildComponent,
    UpdateBuildPopupComponent,
    PackageUpdatePopupComponent,
    ExternalPackageDetailsComponent,
    ComponentUpdateComponent,
    ComponentDependencyComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TenantContinuousUpdateRoutingModule,
    MatIconModule,
    ToolbarModule,
    PaginatorModule,
    TableModule,
    MatProgressBarModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatCardModule,
    PlayButtonModule,
    IconsModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    SidenavHeaderModule,
    ReactiveFormsModule,
    FormsModule,
    ErrorModule,
    MatSlideToggleModule,
    ClipboardModule,
    MatSortModule,
    InstanceDetailsModule,
    SearchFilterModule,
    PipesModule,
    BreadcrumbModule,
    MatSelectModule,
    MatDialogModule,
    NgxSkeletonLoaderModule,
    PageLoaderModule,
    InfraUpgradeModule,
    EnvironmentSizingDocumentsModule
  ]
})
export class TenantContinuousUpdateModule {
}
